export enum OrderStatus {
	PENDING = "PENDING",
	SUCCESS = "SUCCESS",
	CANCELED = "CANCELED",
	REJECTED = "REJECTED",
}


export enum CreatedByType {
	CREATED_BY_ADMIN = "CREATED_BY_ADMIN",
	CREATED_BY_USER = "CREATED_BY_USER"
}